import { Services } from '@sigma-frontend-libs/commons'

import { components, states } from '@/utils'

import RefreshButton from '@/components/button/refresh'
import pagination from '@/components/pagination'
import preloader from '@/components/preloader'
import TemplatesFilter from '@/components/services/templates/filter'
import TemplatesItem from '@/components/services/templates/item'

function renderFilter(h) {
  return h(
    TemplatesFilter,
    {
      props: {
        value: this.filter
      },
      on: {
        input: event => {
          this.filter = event
        }
      }
    }
  )
}

function renderDivider(h) {
  return h(components.divider)
}
function renderSeparator(h) {
  if (this.restData[Services.templates].find.pagination.total > 0) {
    return renderDivider.call(this, h)
  }
}

function renderPagination(h) {
  if (this.restData[Services.templates].find.pagination.total > 0) {
    return h(
      'div',
      {
        class: `${Services.templates}-pagination`
      },
      [
        h(
          pagination,
          {
            props: {
              value: this.restData[Services.templates].find.pagination,
              service: Services.templates
            },
            on: {
              input: event => {
                this.restData[Services.templates].find.pagination = event
              }
            }
          }
        ),

        h(
          RefreshButton,
          {
            props: {
              state: this.restData[Services.templates].find.state,
              shortClickMethod: () => {
                return this.rest[Services.templates].find()
              },
              longClickMethod: () => {
                return this.rest[Services.templates].find({}, { noCache: true })
              }
            }
          }
        )
      ]
    )
  }
}

function renderItem(h, item) {
  return h(
    TemplatesItem,
    {
      props: {
        value: item,
        loading: this.restData[Services.templates].update.state === states.loading
      },
      on: {
        apply: this.applyHandler,
        update: this.updateHandler,
        remove: this.removeHandler
      },
      key: item.id
    }
  )
}
function renderItems(h) {
  return this.restData[Services.templates].find.data.map(item => {
    return renderItem.call(this, h, item)
  })
}
function renderPreloader(h) {
  if (this.restData[Services.templates].find.state === states.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderContent(h) {
  if (this.restData[Services.templates].find.pagination.total > 0) {
    return h(
      components['expansion-panels'],
      {
        props: { flat: true }
      },
      [
        renderItems.call(this, h),
        renderPreloader.call(this, h)
      ]
    )
  }

  return h(components.empty)
}

export default function(h) {
  return h(
    'div',
    {
      class: Services.templates
    },
    [
      renderFilter.call(this, h),
      renderDivider.call(this, h),
      renderPagination.call(this, h),
      renderSeparator.call(this, h),
      renderContent.call(this, h),
      renderSeparator.call(this, h),
      renderPagination.call(this, h)
    ]
  )
}
